'use client';

import { IconShieldCheck, IconUser } from '@tabler/icons-react';

import { ContactMessage } from '@j-s/dr-shared';

interface TicketReplyListProps {
  ticket: ContactMessage;
}

export const TicketReplyList = ({ ticket }: TicketReplyListProps) => {
  return (
    <div className="space-y-3 w-full max-h-[360px] overflow-y-auto pr-1">
      <div className="p-4 rounded-2xl bg-gray-50 border border-gray-200 space-y-2">
        <div className="flex items-center justify-between text-xs text-gray-500">
          <div className="flex items-center gap-1.5 font-semibold text-gray-800">
            <IconUser size={14} className="text-gray-400" />
            <span>{ticket.name} (Twoja wiadomość)</span>
          </div>
          <span>
            {new Date(ticket.createdAt).toLocaleTimeString('pl-PL', {
              hour: '2-digit',
              minute: '2-digit',
            })}
          </span>
        </div>
        <p className="text-sm text-gray-800 whitespace-pre-wrap leading-relaxed">
          {ticket.message}
        </p>
      </div>

      {ticket.replies?.map((rep) => {
        const isAdmin = rep.author === 'admin';

        return (
          <div
            key={rep.id}
            className={`p-4 rounded-2xl border space-y-2 ${
              isAdmin
                ? 'bg-red-50/60 border-red-200 ml-4 sm:ml-6'
                : 'bg-gray-50 border-gray-200 mr-4 sm:mr-6'
            }`}
          >
            <div className="flex items-center justify-between text-xs text-gray-500">
              <div className="flex items-center gap-1.5 font-semibold">
                {isAdmin ? (
                  <>
                    <IconShieldCheck
                      size={15}
                      className="text-red-600 shrink-0"
                    />
                    <span className="text-red-700 font-bold">
                      {rep.authorName || 'Dom Rowerowy - Serwis'}
                    </span>
                  </>
                ) : (
                  <>
                    <IconUser size={14} className="text-gray-400" />
                    <span className="text-gray-800">{rep.authorName}</span>
                  </>
                )}
              </div>
              <span>
                {new Date(rep.createdAt).toLocaleTimeString('pl-PL', {
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </span>
            </div>
            <p className="text-sm text-gray-900 whitespace-pre-wrap leading-relaxed">
              {rep.message}
            </p>
          </div>
        );
      })}
    </div>
  );
};
